import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';

import { fetchDestinationSuggestions, onDestinationSuggestionsCleared, onDestinationSelected } from './actions'
import { updateFilters } from '../search/actions';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';

const mapStateToProps = state => ({
  DestinationSuggestions: state.DestinationSuggestions,
  search: state.Search
});

class DestinationAutosuggest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: null,
      isFocused: false,
      searchTerm: '',
      suggestions: []
    };

    this.timerId = -1;

    this.renderDestinationOption = this.renderDestinationOption.bind(this);
    this.onSearchDestinationSuggestions = this.onSearchDestinationSuggestions.bind(this);
    this.onFetchDestinationSuggestions = this.onFetchDestinationSuggestions.bind(this);
    this.clearDestinationSuggestions = this.clearDestinationSuggestions.bind(this);
    this.hitSearchAPI = this.hitSearchAPI.bind(this);
    this.onOptionSelected = this.onOptionSelected.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.searchTerm !== '' && this.state.searchTerm !== prevState.searchTerm) {
      this.hitSearchAPI();
    }
  }

  hitSearchAPI = () => {
    const { dispatch } = this.props;

    if (this.timerId > 0)
      clearTimeout(this.timerId);

    this.timerId = setTimeout(() => {
      dispatch(fetchDestinationSuggestions(this.state.searchTerm))
        .then(() => { this.onFetchDestinationSuggestions() });
    }, MAGIC_NUMBER.AUTOSUGGESTION_DELAY);
  }

  renderDestinationOption = (option, meta) => {
    const { inputValue, context } = meta;
    const destinationName = option.value.name;
    const destinationAddress = option.value.address;
    const searchedValueIndex = destinationName.toLowerCase().search(inputValue.trim().toLowerCase());
    return (
      <div>
        <div>
          {
            searchedValueIndex >= 0 ?
              <span>
                {destinationName.substring(0, searchedValueIndex)}
                <b>{destinationName.substring(searchedValueIndex, searchedValueIndex + inputValue.length)}</b>
                {destinationName.substring(searchedValueIndex + inputValue.length, destinationName.length)}
              </span> :
              <span>
                {destinationName}
              </span>
          }
        </div>
        {
          context === "menu" ?
            <div>
              <small>{destinationAddress}</small>
            </div> : null
        }
      </div>
    )
  }

  clearDestinationSuggestions = () => {
    const { dispatch } = this.props;
    dispatch(onDestinationSuggestionsCleared());
  }

  onFetchDestinationSuggestions = () => {
    if (!!this.props.DestinationSuggestions.suggestions) {
      let options = [...this.props.DestinationSuggestions.suggestions];
      const suggestions = options.map(option => {
        return { label: option.name, value: option }
      });
      this.setState({
        suggestions: suggestions
      })
    }
  }

  onSearchDestinationSuggestions = (value) => {
    this.setState({
      searchTerm: value
    });
  };

  onOptionSelected = value => {
    const { dispatch } = this.props;

    const geometry = value && value.value ? value.value.geometry : null;
    const { filters } = this.props.search;
    const newFilters = { ...filters };

    newFilters.geometry.lat = geometry ? geometry.lat : undefined;
    newFilters.geometry.lng = geometry ? geometry.lng : undefined;
    newFilters.geometry.locationName = value && value.value ? value.value.name : undefined;

    dispatch(updateFilters(newFilters));
    dispatch(onDestinationSelected(value && value.value ? value.value : null));
    dispatch(onDestinationSuggestionsCleared());

    this.setState({
      selectedValue: value
    })
  }

  render() {
    const { selectedValue } = this.state;
    const { isFetching, validationError } = this.props.DestinationSuggestions;

    return (
      <div>
        <Select
          value={selectedValue}
          options={this.state.suggestions}
          onInputChange={this.onSearchDestinationSuggestions}
          formatOptionLabel={this.renderDestinationOption}
          onChange={this.onOptionSelected}
          placeholder="Search Location"
          defaultOptions
          isClearable
          filterOption={() => { return true; }}
          backspaceRemovesValue
          isLoading={isFetching}
          onFocus={() => {
            this.setState({
              isFocused: true
            })
          }}
          onBlur={() => {
            this.setState({
              isFocused: false
            })
            this.clearDestinationSuggestions();
          }}
          menuIsOpen={this.state.isFocused && !!this.props.DestinationSuggestions.suggestions && !!this.props.DestinationSuggestions.suggestions.length}
        />
        {!!validationError && <div className="invalid-feedback">{validationError}</div>}
      </div>
    );
  }
}

export default connect(mapStateToProps)(DestinationAutosuggest);
